import { AlertCircle } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const PAINS = [
  "Le agenzie ti chiedono un minimo di 500€ al mese per i tuoi social",
  "Sei costretto a spendere migliaia di euro ogni anno solo per essere presente online",
  "Ogni mese l'agenzia prova a venderti altro, senza capire i tuoi veri bisogni da piccola attività",
  "Vorresti creare dei contenuti da solo, ma non sai come fare",
  "I tuoi social sono vuoti e i clienti vanno dal tuo competitor",
  "Non vuoi pagare 500€/mese un'agenzia per due foto",
];

export const PainPoints = () => (
  <section id="problema" data-testid="pain-points-section" className="mx-auto max-w-6xl px-5 py-12">
    <Chapter number="01" label="Il problema" tone="red" />
    <Reveal>
      <div
        data-testid="pain-points-box"
        className="relative mx-auto max-w-3xl overflow-hidden rounded-3xl border-2 border-red-500 bg-red-50/60 p-6 shadow-xl shadow-red-500/5 sm:p-8"
      >
        <div className="text-center">
          <span className="mb-4 inline-block rounded-full bg-red-500 px-4 py-1 text-[11px] font-semibold uppercase tracking-widest text-white">
            Ti suona familiare?
          </span>
          <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
            La tua situazione attuale
          </h2>
        </div>
        <ul className="mt-6 space-y-4">
          {PAINS.map((pain, i) => (
            <Reveal key={pain} delay={i * 0.08}>
              <li data-testid={`pain-point-${i}`} className="flex items-start gap-4">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-100">
                  <AlertCircle className="h-4 w-4 text-red-600" />
                </span>
                <p className="text-base font-medium leading-relaxed text-slate-800">{pain}</p>
              </li>
            </Reveal>
          ))}
        </ul>
        <p className="mt-7 border-t border-red-200 pt-5 text-center font-heading text-lg font-bold text-red-600">
          Risultato: o paghi tanto, o rinunci ad essere online
        </p>
      </div>
    </Reveal>
  </section>
);
